import { render, staticRenderFns } from "./MiembrosComponent.vue?vue&type=template&id=41024ab4&scoped=true&"
import script from "./MiembrosComponent.vue?vue&type=script&lang=js&"
export * from "./MiembrosComponent.vue?vue&type=script&lang=js&"
import style0 from "./MiembrosComponent.vue?vue&type=style&index=0&id=41024ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41024ab4",
  null
  
)

export default component.exports